import React from 'react';

const ShareButton = ({ url, title }) => {


  
  const handleShareClick = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text: 'Check out this link:',
          url,
        });
       // console.log('Shared successfully');
      } catch (error) {
        console.error('Error sharing:', error);
      }
          } else {
      //console.warn('Web Share API not supported in this browser');
    }
  };

  return (
    <button id='shaire' onClick={handleShareClick}>
      Share link
    </button>
  );
};


export default ShareButton;